import { partialRight } from 'lodash-es';

export const formatChannelText = (channel) => {
  let returnText = channel;
  if (channel.trim().indexOf('Infinite Bidding') > -1 || channel.trim().indexOf('Connect') > -1) {
    returnText = 'Private Label';
  } else if (channel.trim().indexOf('Floor') > -1) {
    returnText = 'Floor Bidder';
  }

  return returnText;
};

export const formatToDecimal = (value, withSeparator = false) => {
  const parsedValue = Number.isNaN(value) ? 0 : value;
  const decimalValue = Number(parsedValue).toFixed(2);

  return withSeparator
    ? (new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 })).format(decimalValue)
    : decimalValue;
};

export const formatToNumber = (value) => {
  const valueToParse = typeof value === 'string' ? value.replace(',', '') : value;

  return Number.isNaN(Number(valueToParse)) ? 0 : parseFloat(valueToParse || 0);
};

export const formatToDecimalWithSeparator = partialRight(formatToDecimal, true);

export const formatJsonToCsv = (data) => {
  if (!Array.isArray(data) || !data.length) {
    return '';
  }

  const header = Object.keys(data[0]);
  const replacer = (_, value) => value ?? '';
  const dataRows = data.map((row) => header
    .map((fieldName) => JSON.stringify(row[fieldName], replacer))
    .join(','));

  return [header.join(','), ...dataRows].join('\r\n');
};

export const titleCase = (str) => str.toLowerCase().replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
